import { useListResourceLabelsQuery } from '@axilon-apps/domains-ontology-ui-state'

import { LabelEditor } from '../../../components/resource-labels'

export interface ConfigLabelsSectionProps {
  labels: readonly string[]
  onChange: (next: string[]) => void | Promise<void>
  disabled?: boolean
}

/**
 * Editable Labels block on config detail pages. Persists via the parent
 * `onChange` (typically a PATCH with `{ labels }`).
 *
 * Catalog is refetched on mount; config create/update/delete also invalidate
 * it via `resourceLabelsBridge` so autocomplete stays current after tagging.
 */
export function ConfigLabelsSection({ labels, onChange, disabled }: ConfigLabelsSectionProps) {
  const { data: catalog = [] } = useListResourceLabelsQuery(undefined, {
    refetchOnMountOrArgChange: true
  })
  return (
    <LabelEditor
      labels={labels}
      onChange={onChange}
      catalog={catalog.filter((e) => e.count > 0).map((e) => ({ label: e.name, count: e.count }))}
      disabled={disabled}
    />
  )
}
